import router from "@/router";
import serviceFactory from "@/service/factory";
import notification from "@/notify";
import { HttpServiceV2 } from "@/service/HTTP";
import Vue from "vue";

const HTTPV2 = new HttpServiceV2("/v2/delete");

console.log({ HTTPV2 });

const showOverlayAction = (type, entity) => {
  return () => {
    const id = entity ? entity.id : null;
    router.push({
      name: type,
      params: { id },
      query: router.currentRoute.query
    });
  };
};

const performDelete = (entity, context) => {
  return new Promise((resolve, reject) => {
    const service = serviceFactory[entity.type];
    service
      .delete(entity.id)
      .then(res => {
        context.$store.dispatch("LOAD_DASHBOARD");
        context.$modal.hide("dialog");
        resolve(res);
        context.$nextTick(() =>
          context.$util.eventbus.$emit("removeEntity", entity)
        );
      })
      .catch(e => {
        notification.error(e.message);
        Vue.$log.error(e);
        reject(e);
      });
  });
};

const showDeleteDialog = (entity, context, text) => {
  return new Promise((resolve, reject) => {
    context.$modal.show("dialog", {
      title: "Löschen",
      text,
      buttons: [
        {
          title: "Ja",
          handler: () => performDelete(entity, context).then(resolve).catch(reject)
        },
        {
          title: "Nein",
          handler: () => {
            context.$modal.hide("dialog");
            resolve({ cancelled: true });
          }
        }
      ]
    });
  });
};

const deleteEntityAction = (entity, context) => {
  return new Promise((resolve, reject) => {
    Vue.$log.debug("CONTEXT", context);
    Vue.$log.debug(entity);
    HTTPV2.get(null, {
      type: entity.type,
      id: entity.id
    })
      .then(res => {
        showDeleteDialog(entity, context, res.data.html).then(resolve).catch(reject);
      })
      .catch(e => {
        Vue.$log.warn("V2 delete endpoint not available, using fallback dialog", e);
        const fallbackText = `Wollen Sie <b>"${entity.name || ""}"</b> wirklich löschen?`;
        showDeleteDialog(entity, context, fallbackText).then(resolve).catch(reject);
      });
  });
};

function getActions(label, type) {
  return [
    {
      name: label,
      action: showOverlayAction(type),
      type
    },
    {
      name: "Bearbeiten",
      action: entity => showOverlayAction(type, entity)(),
      type
    },
    {
      name: "Löschen",
      action: deleteEntityAction,
      type
    }
  ];
}

function getActionsWithoutElement(label, type) {
  return [
    {
      name: label,
      action: showOverlayAction(type),
      type
    }
  ];
}

export default {
  BOOK: getActions("Neues Buch anlegen", "BOOK"),
  BOOK_PACKAGE: getActions("Neues Package anlegen", "BOOK_PACKAGE"),
  CHAPTER: getActions("Neues Kapitel anlegen", "CHAPTER"),
  BOOK_PACKAGE_EMPTY_ELEMENT: getActionsWithoutElement(
    "Neues Package anlegen",
    "BOOK_PACKAGE"
  ),
  CHAPTER_EMPTY_ELEMENT: getActionsWithoutElement(
    "Neues Kapitel anlegen",
    "CHAPTER"
  ),
  TOPIC_EMPTY_ELEMENT: getActionsWithoutElement("Neues Thema anlegen", "TOPIC"),
  COMPETENCE_MODULE: getActions(
    "Neues Kompetenzmodul anlegen",
    "COMPETENCE_MODULE"
  ),
  SCHOOL_SUBJECT: getActions("Neues Fach anlegen", "SCHOOL_SUBJECT"),
  SCHOOL_TYPE: getActions("Neuen Schultyp anlegen", "SCHOOL_TYPE"),
  SKILL: getActions("Neue Fertigkeiten anlegen", "SKILL"),
  TASK: getActions("Neue Aufgabe anlegen", "TASK"),
  TASK_TYPE: getActions("Neuen Aufgabentyp anlegen", "TASK_TYPE"),
  TOPIC: getActions("Neues Thema anlegen", "TOPIC"),
  FILTER: getActions("Neuen Filter anlegen", "FILTER"),
  CONTENT_TYPE: getActions("Neuen Inhaltstypen anlegen", "CONTENT_TYPE")
};
